module.exports = __webpack_public_path__ + "fonts/ObjectSans-Heavy.79dee7c7.otf";